import React, { Component } from 'react';
import { DropTarget } from 'react-drag-drop-container';
import { Stage, Layer, Rect } from 'react-konva';
import ReactResizeDetector from 'react-resize-detector';

import { GenericComponentCanvas } from "./componentCanvas/GenericComponentCanvas";
import { NotesComponentCanvas } from "./componentCanvas/NotesComponentCanvas";
import { ImageComponentCanvas } from "./componentCanvas/ImageComponentCanvas";
import { QrCodeComponentCanvas } from "./componentCanvas/QrCodeComponentCanvas";
import { ExceptionsComponentCanvas } from "./componentCanvas/ExceptionsComponentCanvas";
import { StopInformationComponentCanvas } from "./componentCanvas/StopInformationComponentCanvas";
import { LineInformationComponentCanvas } from "./componentCanvas/LineInformationComponentCanvas";
import { DayTimesheetComponentCanvas } from "./componentCanvas/DayTimesheetComponentCanvas";
import { CompactDayTimesheetComponentCanvas } from "./componentCanvas/CompactDayTimesheetComponentCanvas";
import { VerticalDayTimesheetComponentCanvas } from "./componentCanvas/VerticalDayTimesheetComponentCanvas";
import { VerticalTabularDayTimesheetComponentCanvas } from './componentCanvas/VerticalTabularDayTimesheetComponentCanvas';
import { HorizontalTabularDayTimesheetComponentCanvas } from './componentCanvas/HorizontalTabularDayTimesheetComponentCanvas';
import { VertivalStopsListComponentCanvas } from "./componentCanvas/VertivalStopsListComponentCanvas";
import { HorizontalStopsListComponentCanvas } from "./componentCanvas/HorizontalStopsListComponentCanvas";
import { SmsBusComponentCanvas } from "./componentCanvas/SmsBusComponentCanvas";

export class LayoutCanvas extends Component {
    constructor(props) {
        super(props);

        this.state = {
            componentsCanvas: {
                notes: NotesComponentCanvas,
                image: ImageComponentCanvas,
                qrCode: QrCodeComponentCanvas,
                exceptions: ExceptionsComponentCanvas,
                stopInformation: StopInformationComponentCanvas,
                lineInformation: LineInformationComponentCanvas,
                dayTimesheet: DayTimesheetComponentCanvas,
                verticalStopsList: VertivalStopsListComponentCanvas,
                horizontalStopsList: HorizontalStopsListComponentCanvas,
                smsBus: SmsBusComponentCanvas,
                compactDayTimesheet: CompactDayTimesheetComponentCanvas,
                verticalDayTimesheet: VerticalDayTimesheetComponentCanvas,
                verticalTabularDayTimesheet: VerticalTabularDayTimesheetComponentCanvas,
                horizontalTabularDayTimesheet: HorizontalTabularDayTimesheetComponentCanvas,
            }
        }
    }

    render() {
        const { layout, selectedComponentInternalId, canvas } = this.props;
        const { componentsCanvas } = this.state;

        const components = layout.components.slice(0).sort((a, b) => a.positionZ - b.positionZ);
        const componentsElements = [];
        for (const idx in components) {
            const component = Object.assign({}, components[idx]);
            const key = `${String.fromCharCode(component.internalId)}-${component.internalId}-${component.drawPositionX}-${component.drawPositionY}`;

            let componentCanvas = componentsCanvas[component.type.slice(0, 1).toLowerCase().concat(component.type.slice(1))];
            if (null === componentCanvas || undefined === componentCanvas) {
                componentCanvas = GenericComponentCanvas;
            }

            componentsElements.push(
                React.createElement(
                    componentCanvas,
                    {
                        key: key,
                        component: component,
                        isSelected: selectedComponentInternalId === component.internalId,
                        dimentionsRatio: canvas.dimentionsRatio,
                        draggable: true,
                        onDragEnd: (a) => this.props.onMoveExistingComponent(a, component),
                        onComponentClick: this.props.onComponentClick
                    }
                )
            );
        }

        return (
            <ReactResizeDetector
                handleWidth
                onResize={this.props.onResize}>
                <div style={{ textAlign: "-webkit-center" }}>
                    <div id="layout">
                        <DropTarget targetKey="layoutBuilder"
                            onDragEnter={this.props.onDragEnter}
                            onDragLeave={this.props.onDragLeave}
                            onHit={this.props.onHitLayout} >
                            <Stage 
                                width={canvas.width + 10} 
                                height={canvas.height + 10}
                                style={{cursor: "pointer"}} >
                                <Layer>
                                    <Rect x={5}
                                        y={5}
                                        width={canvas.width}
                                        height={canvas.height}
                                        fill="white"
                                        shadowBlur={5} />
                                    {componentsElements}
                                </Layer>
                            </Stage>
                        </DropTarget>
                    </div>
                </div>
            </ ReactResizeDetector>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/bussched/layoutConfigurations/LayoutCanvas.js